<div class="bl-check-wrap bl-margin-bottom--5" *ngFor="let item of options">
    <input type="radio" (change)="setValue(item.value)" class="switch-input" [name]="name" [id]="setId(name)" [value]="item.value"
        [checked]="item.value === value">
    <label (click)="setValue(item.value)">
        {{ item.label }}
    </label>
</div>
